import { StyledDialog } from '@lib/common';
import { DialogContent, Typography, DialogActions, Button } from '@material-ui/core';
import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function InvoiceRunGeneratingModal({ open, onClose }: Props) {
  return (
    <StyledDialog open={open} title="Export Generating" onClose={onClose}>
      <DialogContent>
        <Typography variant="body1" align="center" style={{ margin: '1rem' }}>
          An export for this run is currently being generated.
        </Typography>
        <Typography variant="subtitle1" align="center" style={{ margin: '1rem' }}>
          Please try again in a few minutes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="contained"
          color="default"
          onClick={onClose}
          data-testid="closeButton"
        >
          Close
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
